<template lang="pug">
.content
    setting-title(
        title="人群细分设置"
    )
    .zone.content-part
        domain-select(extra="为网站$domain绑定人群细分", @change="onDomainChange")
    .toolbar-row
      .btn.btn-primary.btn-big(@click="openAddCrowdModal") 新建人群
    .zone
        table.data-table
          thead
            tr
              th(v-for="item in columns",
                :style="{minWidth: item.width + 'px'}"
              ) {{item.title}}
          //loading 
          tbody(v-if="isLoading")
            tr
              td.loading(:colspan="4")
                img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")

          //no result
          tbody(v-else-if="!isLoading && tableDataList.length == 0")
            tr
              td.noresult(:colspan="4") 暂无相关数据

          tbody(v-else)
            tr(v-for="(item,index) in tableDataList")
              td(v-for="columnItem in columns")
                span.system(v-show="columnItem.key == 'name' && item.sys_flag == 1") 系统
                span(
                  v-html="columnItem.render(index, item[columnItem.key],item)"
                  v-if="columnItem.render")
                span(v-else-if="columnItem.key != 'opt'")
                  | {{item[columnItem.key]}}
                span(v-else)
                  a.mgr(@click.prevent="openShowCrowdModal(item)" v-if="item.sys_flag === 1") 查看
                  a.mgr(@click.prevent="openEditCrowdModal(item)" v-else) 编辑
                  a.mgr(@click.prevent="openCopyCrowdModal(item)") 复制
                  //a.mgr(@click.prevent="syncDMP") 同步至DMP
                  a.mgr(v-if="isDjPlatform !== 0" @click.prevent="gotoDetail(item)") 访客细查
                  a.mgr(@click.prevent="removeCrowd(item)" v-if="item.sys_flag != 1") 删除
        
        v-pagination(
          :total="total",
          :pn="pn",
          :ps="ps",
          v-if="total > ps",
          @updatepage="updatePage")

    v-modal(:visible="syncSetting",
      title="同步DMP设置",
      @closemodal="closeSyncSetting()")
      .modal-bd.form.sync-container
        .item
          .label 点睛账户：
          .control.no-margin
            v-select(
              v-model="selectAccount",
              :options="dianjingAccountList"
              )
        .item
          .label 人群名称：
          .control
            v-input(name="name",
              v-model="crowdName",
              placeholder="请输入人群名称"
              )
        .item
          .label 人群计算时间：
          .control
            | 最近
            span 
              v-select(
                v-model="selectDays",
                :options="daysOptions"
                )
            | 天
            span.custom-day 自定义
        .item
          .label 人群规模：
          .control {{crowdNum}}
        .item
          .btn-container
            button.btn.btn-primary.btn-small.btn-mgr(@click="submitSync()") 确认
            button.btn.btn-default.btn-small(@click="closeSyncSetting") 取消
    v-modal(:visible="crowdVisible",
      :title="modalTitle",
      @closemodal="closeCrowdModal()",
      ref="formCrowdModal")
      .modal-bd
        CrowdTemplate(
          v-if="crowdVisible",
          :crowd="crowd",
          :type="crowdType",
          @validate="submit",
          @updateItem="centerModal")
          template(slot="btnwraper" scope="props")
            .btn-container
                button.btn.btn-primary.btn-small.btn-mgr(
                  @click="submitModal(props.crowd)",
                  type="button",
                  :disabled="crowdType=='show'"
                  ) 确认
                button.btn.btn-default.btn-small(
                  @click="closeCrowdModal",
                  type="button",
                  :disabled="crowdType=='show'"
                  ) 取消
    v-modal(:visible="isMv",
        ref="mvModal"
        @closemodal="gotoSetting",
        title=""
      )
      .modal-bd
        p.text-content 使用该功能需要在网站部署360分析代码
        p.mv-container
          button.btn.btn-primary.btn-small.btn-mgr(@click="gotoSetting()") 去设置


</template>

<script>
/* global _ */
import Store from '../../store/store.js'
import BaseTable from '../../component/base-table.vue'
import CrowdTemplate from '../../component/crowdTemplate.vue'

export default {
  store: Store,
  components: {
    BaseTable,
    CrowdTemplate
  },
  data () {
    return {
      isMv: false,
      crowd: {},
      crowdType: '',
      crowdNum: '-',
      crowdName: '',
      selectDays: '',
      selectAccount: 1,
      dianjingAccountList: [
        {
          label: 'test',
          value: 1
        }
      ],
      syncSetting: false,
      daysOptions: [
        {
          label: '7',
          value: 7
        },
        {
          value: 30,
          label: '30'
        },
        {
          label: '37',
          value: 37
        },
        {
          value: 90,
          label: '90'
        }
      ],
      crowdVisible: false,
      modalApi: '',
      modalTitle: '新建人群',
      domainId: 0,
      tableDataList: [],
      total: 0,
      pn: 1,
      ps: 10,
      columns: [
        {
          title: '人群名称',
          key: 'name',
          width: '300'
        },
        {
          title: '人群类型',
          key: 'sys_flag',
          width: '200',
          render (index, value, item, type) {
            return Number(value) === 0 ? '自定义人群' : '系统默认人群'
          }
        },
        {
          title: '创建时间',
          key: 'createtime',
          width: '200'
        },
        {
          title: '操作',
          key: 'opt'
        }
      ]
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.tableLoading
    },
    isDjPlatform () {
      return window.$isDjPlatform
    },
    testPlaceholder () {
      return '请选择维度'
    },
    uiError () {
      return this.$store.state.uiError
    },
    startValidCrowdForm () {
      return this.$store.state.startValidCrowdForm
    }
  },
  created () {
    this.domainId = this.$store.state.domainId
    this.getCrowdList()
  },
  watch: {
    uiError () {
      if (this.uiError.errMsg) {
        this.$Modal.warn(this.uiError.errMsg)
      }
    }
  },
  methods: {
    gotoSetting () {
      this.$store.dispatch('SET_MV_ADDSITE', true)
      this.$router.push('/setting/sites')
    },
    getCrowdList () {
      this.$store.dispatch('SET_TABLE_LOADING', true)
      const crowdPromise = this.$http.get('/api/crowd/list', {
        params: {
          domainId: this.domainId,
          ps: this.ps,
          pg: this.pn
        }
      })
      this.$store.dispatch('VUE_HTTP', [crowdPromise]).then(res => {
        this.$store.dispatch('SET_TABLE_LOADING', false)
        if (!res.errno) {
          this.total = res.total
          this.tableDataList = res.list
        } else {
          this.total = 0
          this.tableDataList = []
        }
      })
    },
    centerModal (crowd) {
      const maxLength = 6
      if (crowd.attr_rule.length + crowd.action_rule.length < maxLength) {
        const modalRef = this.$refs.formCrowdModal
        const centerFn = modalRef._centerModal
        this.$nextTick(() => centerFn && modalRef._centerModal())
      }
    },
    onDomainChange (domain) {
      this.domainId = domain.id
      this.updatePage(1)
    },
    parseJSON (rule) {
      const canParse = _.isNull(rule) || rule === ''
      return canParse ? [] : JSON.parse(rule)
    },
    openShowCrowdModal (item) {
      this.crowd = {
        name: item.name,
        attr_rule: this.parseJSON(item.attr_rule),
        attr_calc: item.attr_calc,
        action_rule: this.parseJSON(item.action_rule),
        action_calc: item.action_calc
      }
      this.modalTitle = '查看人群'
      this.crowdType = 'show'
      this.crowdVisible = true
    },
    openCopyCrowdModal (item) {
      this.crowd = {
        name: '',
        attr_rule: this.parseJSON(item.attr_rule),
        attr_calc: item.attr_calc,
        action_rule: this.parseJSON(item.action_rule),
        action_calc: item.action_calc
      }
      this.modalTitle = '新建人群'
      this.crowdType = 'add'
      this.modalApi = '/api/crowd/add'
      this.crowdVisible = true
    },
    openEditCrowdModal (item) {
      this.crowd = {
        name: item.name,
        id: item.id,
        attr_rule: this.parseJSON(item.attr_rule),
        attr_calc: item.attr_calc,
        action_rule: this.parseJSON(item.action_rule),
        action_calc: item.action_calc
      }
      this.modalTitle = '编辑人群'
      this.crowdType = 'edit'
      this.modalApi = '/api/crowd/edit'
      this.crowdVisible = true
    },
    openAddCrowdModal () {
      /* 使用后端校验
      const maxCrowdLength = 100
      if (this.total >= maxCrowdLength) {
        this.$Modal.alert(`最多创建${maxCrowdLength}个人群`)
        return
      } */
      this.isMvSite().then(res => {
        if (!res.errno) {
          if (!res.isMv) {
            this.modalTitle = '新建人群'
            this.crowdType = 'add'
            this.modalApi = '/api/crowd/add'
            this.crowdVisible = true
          } else {
            this.isMv = true
          }
        }
      })
    },
    isMvSite () {
      const mvPromise = this.$http.get('/api/crowd/isMv', {
        params: {
          domainId: this.$store.state.domainId
        }
      })
      return this.$store.dispatch('VUE_HTTP', [mvPromise])
    },
    closeCrowdModal () {
      this.crowdVisible = false
      this.crowd = {}
      this.crowdType = ''
    },
    submitModal (props) {
      this.$store.dispatch('SET_START_CROWDVALID', true)
    },
    ruleFormat (rules, type) {
      const newRules = _.map(rules, item => {
        const newItem = {
          d: item.d,
          d_r: item.d_r,
          d_v: item.d_v,
          d_id: item.d_id
        }
        if (type === 'action') {
          newItem.m_r = item.m_r
          newItem.m_v = item.m_v
        }
        return newItem
      })
      return JSON.stringify(newRules)
    },
    submit (props) {
      const params = {
        domainId: this.$store.state.domainId,
        name: props.name,
        attr_calc: props.attr_calc,
        attr_rule: this.ruleFormat(props.attr_rule),
        action_rule: this.ruleFormat(props.action_rule, 'action'),
        action_calc: props.action_calc
      }
      if (this.crowdType === 'edit') {
        params.clusterid = props.id
      }
      // upload info
      const submitPromise = this.$http.post(this.modalApi, params, {
        emulateJSON: true
      })
      this.$store.dispatch('VUE_HTTP', [submitPromise]).then(res => {
        if (!res.errno) {
          this.updatePage(1)
          this.closeCrowdModal()
        }
      })
    },
    submitSync () {
      this.closemodal()
    },
    removeCrowd (item) {
      const removePromise = this.$http.get('/api/crowd/del', {
        params: {
          domainId: this.domainId,
          clusterid: item.id
        }
      })
      this.$Modal.confirm('确定删除?', res => {
        if (!res) return
        this.$store.dispatch('VUE_HTTP', [removePromise]).then(res => {
          if (!res.errno) {
            this.updatePage(1)
          }
        })
      })
    },
    syncDMP () {
      this.syncSetting = true
    },
    closeSyncSetting () {
      this.syncSetting = false
    },
    updatePage (pn) {
      this.pn = pn
      this.getCrowdList()
    },
    gotoDetail (item) {
      this.$store.dispatch('SET_CLUSTER_ID', item.id)
      this.$router.push('/web/visitInfo')
    }
  }
}
</script>

<style scoped>
.opt-table thead tr {
  background: #596980;
  th,
  .sort {
    color: #fff;
  }
  .sorted {
    color: #999;
  }
}
.content-part {
  overflow: visible;
}
.sync-container {
  padding: 0 25px;
  .label {
    min-width: 90px;
  }
}
.modal,
.modal-bd {
  min-width: 800px;
}
.mgr {
  margin-right: 20px;
}
.btn-container {
  margin: 0 0 25px 85px;
}
.btn-mgr {
  margin-right: 15px;
}
.no-margin .v-select {
  margin: 0;
}
.mv-container {
  text-align: center;
}
.margin-nobtn {
  margin-bottom: 20px;
}
p.text-content {
  text-align: center;
  font-size: 14px;
  margin: 20px;
}
.system {
  display: inline-block;
  width: 32px;
  line-height: 20px;
  font-size: 12px;
  background: #73ace6;
  text-align: center;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// crowdSegmentation.vue?708b3ba4